import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const initialState = {
  userId:"",
  specialAccessHeaderMap: {
    dashboard: false,
    parameter: false,
    disbursementCreate: false,
    disbursementList: false,
    disbursementApprove: false,
  },

  fieldAccessMap: {
    requestDateFutureCount: false,
    disbursementDate: false,
    requestDateBackCount: false,
  },
};
const getHeaderAccessData = async (state, data) => {
  setSpecialFlag(state, data);
};
const setSpecialFlag = (state, data) => {
  let accessMap = {};
  data.response.header.forEach((element) => {
    switch (element.moduleId) {
      /*  case "MD000":
        accessMap.dashboard = element.isSpecial;
        break; */
      case "MD001":
        accessMap.disbursement = element.isSpecial;
        if (element.isSpecial) {
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      case "MD002":
        accessMap.nach = element.isSpecial;
        if (element.isSpecial) {
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      case "MD003":
        accessMap.parameter = element.isSpecial;
        break;
      case "MD004":
        accessMap.fileReceipt = element.isSpecial;
        if (element.isSpecial) {
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      case "MD005":
        accessMap.filePayment = element.isSpecial;
        if (element.isSpecial) {
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      case "MD006":
        accessMap.journalVoucher = element.isSpecial;
        if (element.isSpecial) {
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      case "MD007":
        accessMap.return = element.isSpecial;
        if (element.isSpecial) {
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      case "MD008":
        accessMap.additionalFee = element.isSpecial;
        if (element.isSpecial) {
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      case "MD009":
        accessMap.batch = element.isSpecial;
        break;
      case "MD010":
        accessMap.security = element.isSpecial;
        if (element.isSpecial) {
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      case "MD011":
        accessMap.master = element.isSpecial;
        if (element.isSpecial) {
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      case "MD012":
        accessMap.reports = element.isSpecial;
        if (element.isSpecial) {
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      case "MD013":
        accessMap.loanClosure = element.isSpecial;
        break;
      case "MD014":
        accessMap.reSchedulement = element.isSpecial;
        break;
      case "MD015":
        accessMap.customerOneView = element.isSpecial;
        break;
        case "MD016":
        accessMap.letterGeneration = element.isSpecial;
        if(element.isSpecial){
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
        case "MD017":
        accessMap.losData = element.isSpecial;
        if(element.isSpecial){
          checkProgramAccess(state, data, element.moduleId, accessMap);
        }
        break;
      default:
        break;
    }
    state.specialAccessHeaderMap = accessMap;
  });
};
const checkProgramAccess = (state, data, moduleId, accessMap) => {
  data.response.program.forEach((element) => {
    element.forEach((program) => {
      if (program.moduleId === moduleId) {
        switch (program.programId) {
          case "DB01":
            accessMap.disbursementCreate = program.programAccess;
            enableDisbursementParent(state, accessMap);
            break;
          case "DB02":
            accessMap.disbursementList = program.programAccess;
            enableDisbursementParent(state, accessMap);
            break;
          case "DB03":
            accessMap.disbursementApprovalList = program.programAccess;
            enableDisbursementParent(state, accessMap);
            break;
          case "NC01":
            accessMap.nachMandate = program.programAccess;
            enableNachParent(state, accessMap);
            break;
          case "NC02":
            accessMap.nachInward = program.programAccess;
            enableNachParent(state, accessMap);
            break;
          case "NC03":
            accessMap.nachVerification = program.programAccess;
            enableNachParent(state, accessMap);
            break;
          case "NC04":
            accessMap.nachActivation = program.programAccess;
            enableNachParent(state, accessMap);
            break;
          case "NC05":
            accessMap.nachDeactivation = program.programAccess;
            enableNachParent(state, accessMap);
            break;
          case "NC06":
            accessMap.nachExclude = program.programAccess;
            enableNachParent(state, accessMap);
            break;
          case "NC07":
            accessMap.nachRetrieval = program.programAccess;
            enableNachParent(state, accessMap);
            break;
          case "NC08":
            accessMap.nachPosting = program.programAccess;
            enableNachParent(state, accessMap);
            break;
          case "NC09":
            accessMap.nachExtraction = program.programAccess;
            enableNachParent(state, accessMap);
            break;
          case "FR01":
            accessMap.fileReceiptCreate = program.programAccess;
            enableFileReceiptParent(state, accessMap);
            break;
          case "FR02":
            accessMap.fileReceiptView = program.programAccess;
            enableFileReceiptParent(state, accessMap);
            break;
          case "FR03":
            accessMap.fileReceiptModify = program.programAccess;
            enableFileReceiptParent(state, accessMap);
            break;
          case "FP01":
            accessMap.filePaymentCreate = program.programAccess;
            enableFilePaymentParent(state, accessMap);
            break;
          case "FP02":
            accessMap.filePaymentView = program.programAccess;
            enableFilePaymentParent(state, accessMap);
            break;
          case "FP03":
            accessMap.filePaymentModify = program.programAccess;
            enableFilePaymentParent(state, accessMap);
            break;
          case "FP04":
            accessMap.filePaymentDelete = program.programAccess;
            enableFilePaymentParent(state, accessMap);
            break;
          case "FP05":
            accessMap.filePaymentApproval = program.programAccess;
            enableFilePaymentParent(state, accessMap);
            break;
          case "JV01":
            accessMap.journalVoucherCreate = program.programAccess;
            enableJournalVoucherparent(state, accessMap);
            break;
          case "JV02":
            accessMap.journalVoucherView = program.programAccess;
            enableJournalVoucherparent(state, accessMap);
            break;
          case "JV03":
            accessMap.journalVoucherModify = program.programAccess;
            enableJournalVoucherparent(state, accessMap);
            break;
          case "JV04":
            accessMap.journalVoucherDelete = program.programAccess;
            enableJournalVoucherparent(state, accessMap);
            break;
          case "JV05":
            accessMap.journalVoucherApprove = program.programAccess;
            enableJournalVoucherparent(state, accessMap);
            break;
          case "RT01":
            accessMap.chequeReturn = program.programAccess;
            enableReturnParent(state, accessMap);
            break;
          case "RT02":
            accessMap.mandateReturn = program.programAccess;
            enableReturnParent(state, accessMap);
            break;
          case "RT03":
            accessMap.bulkReturn = program.programAccess;
            enableReturnParent(state, accessMap);
            break;
          case "AF01":
            accessMap.additionalAccrual = program.programAccess;
            enableAdditionalParent(state, accessMap);
            break;
          case "AF02":
            accessMap.additionalWaiver = program.programAccess;
            enableAdditionalParent(state, accessMap);
            break;
          case "SP01":
            accessMap.securityChequeCreate = program.programAccess;
            enableSecurityParent(state, accessMap);
            break;
          case "SP02":
            accessMap.securityChequeModify = program.programAccess;
            enableSecurityParent(state, accessMap);
            break;
          case "MS01":
            accessMap.cashHandlingCharge = program.programAccess;
            enableMasterParent(state, accessMap);
            break;
          case "MS02":
            accessMap.prePaymentHandling = program.programAccess;
            enableMasterParent(state, accessMap);
            break;
          case "MS03":
            accessMap.specialFunctionAccess = program.programAccess;
            enableMasterParent(state, accessMap);
            break;
          case "MS04":
            accessMap.listOfValue = program.programAccess;
            enableMasterParent(state, accessMap);
            break;
          case "MS05":
            accessMap.losMaster = program.programAccess;
            enableMasterParent(state, accessMap);
            break;
            case "MS06":
              accessMap.feeDefinition = program.programAccess;
              enableMasterParent(state, accessMap);
              break;
              case "MS07":
                accessMap.feeRateDefinition = program.programAccess;
                enableMasterParent(state, accessMap);
                break;
          case "RP01":
            accessMap.amortCalculation = program.programAccess;
            enableReportParent(state, accessMap);
            break;
          case "RP02":
            accessMap.reportProcess = program.programAccess;
            enableReportParent(state, accessMap);
            break;
          case "RP03":
            accessMap.settlementFigureReport = program.programAccess;
            enableReportParent(state, accessMap);
            break;
          case "RP04":
            accessMap.repaymentStructure = program.programAccess;
            enableReportParent(state, accessMap);
            break;
            case "LG01":
            accessMap.letterGenerationCreate = program.programAccess;
            enableLetterParent(state, accessMap);
            break;
            case "LG02":
              accessMap.letterGenerationTrigger = program.programAccess;
              enableLetterParent(state, accessMap);
            break;
            case "LS01":
              accessMap.leadInformation = program.programAccess;
              enableLosParent(state, accessMap);
            break;
            case "LS02":
              accessMap.customerInformation = program.programAccess;
              enableLosParent(state, accessMap);
            break;
            case "LS03":
              accessMap.applicantDetails = program.programAccess;
              enableLosParent(state, accessMap);
            break;
          default:
            break;
        }
      }
    });
  });
  state.specialAccessHeaderMap = accessMap;
};
const enableDisbursementParent = (state, accessMap) => {
  if (
    accessMap.disbursementCreate ||
    accessMap.disbursementList ||
    accessMap.disbursementApprovalList
  ) {
    accessMap.disbursement = true;
  } else {
    accessMap.disbursement = false;
  }
  state.specialAccessHeaderMap = accessMap;
};
const enableNachParent = (state, accessMap) => {
  if (
    accessMap.nachMandate ||
    accessMap.nachInward ||
    accessMap.nachVerification ||
    accessMap.nachActivation ||
    accessMap.nachDeactivation ||
    accessMap.nachExclude ||
    accessMap.nachRetrieval ||
    accessMap.nachPosting ||
    accessMap.nachExtraction
  ) {
    accessMap.nach = true;
  } else {
    accessMap.nach = false;
  }

  state.specialAccessHeaderMap = accessMap;
};

const enableFileReceiptParent = (state, accessMap) => {
  if (
    accessMap.fileReceiptCreate ||
    accessMap.fileReceiptModify ||
    accessMap.fileReceiptView
  ) {
    accessMap.fileReceipt = true;
  } else {
    accessMap.fileReceipt = false;
  }

  state.specialAccessHeaderMap = accessMap;
};
const enableFilePaymentParent = (state, accessMap) => {
  if (
    accessMap.filePaymentCreate ||
    accessMap.filePaymentView ||
    accessMap.filePaymentModify ||
    accessMap.filePaymentDelete ||
    accessMap.filePaymentApproval
  ) {
    accessMap.filePayment = true;
  } else {
    accessMap.filePayment = false;
  }

  state.specialAccessHeaderMap = accessMap;
};
const enableJournalVoucherparent = (state, accessMap) => {
  if (
    accessMap.journalVoucherCreate ||
    accessMap.journalVoucherView ||
    accessMap.journalVoucherModify ||
    accessMap.journalVoucherDelete ||
    accessMap.journalVoucherApprove
  ) {
    accessMap.journalVoucher = true;
  } else {
    accessMap.journalVoucher = false;
  }

  state.specialAccessHeaderMap = accessMap;
};

const enableReturnParent = (state, accessMap) => {
  if (
    accessMap.chequeReturn ||
    accessMap.mandateReturn ||
    accessMap.bulkReturn
  ) {
    accessMap.return = true;
  } else {
    accessMap.return = false;
  }
  state.specialAccessHeaderMap = accessMap;
};

const enableAdditionalParent = (state, accessMap) => {
  if (accessMap.additionalAccrual || accessMap.additionalWaiver) {
    accessMap.additionalFee = true;
  } else {
    accessMap.additionalFee = false;
  }
  state.specialAccessHeaderMap = accessMap;
};
const enableMasterParent = (state, accessMap) => {
  if (
    accessMap.cashHandlingCharge ||
    accessMap.prePaymentHandling ||
    accessMap.specialFunctionAccess ||
    accessMap.listOfValue ||
    accessMap.losMaster||
    accessMap.feeDefinition||
    accessMap.feeRateDefinition
  ) {
    accessMap.master = true;
  } else {
    accessMap.master = false;
  }
  state.specialAccessHeaderMap = accessMap;
};
const enableSecurityParent = (state, accessMap) => {
  if (accessMap.securityChequeCreate || accessMap.securityChequeModify) {
    accessMap.security = true;
  } else {
    accessMap.security = false;
  }
  state.specialAccessHeaderMap = accessMap;
};
const enableReportParent = (state, accessMap) => {
  if (
    accessMap.amortCalculation ||
    accessMap.reportProcess ||
    accessMap.settlementFigureReport ||
    accessMap.repaymentStructure
  ) {
    accessMap.reports = true;
  } else {
    accessMap.reports = false;
  }
  state.specialAccessHeaderMap = accessMap;
};
const enableLetterParent=(state,accessMap)=>{
  if (accessMap.letterGenerationCreate || accessMap.letterGenerationTrigger) {
    accessMap.letterGeneration = true;
  } else {
    accessMap.letterGeneration = false;
  }
  state.specialAccessHeaderMap = accessMap;
};
const enableLosParent=(state,accessMap)=>{
  if (accessMap.leadInformation || accessMap.customerInformation|| accessMap.applicantDetails) {
    accessMap.losData = true;
  } else {
    accessMap.losData = false;
  }
  state.specialAccessHeaderMap = accessMap;
}
const getDetailData = (state, data) => {
  let detailAccessMap = {};
  data.forEach((element) => {
    switch (element.moduleId) {
      case "MD001":
        switch (element.programId) {
          case "DB01":
            switch (element.paramId) {
              case 1:
                detailAccessMap.disbursementDateEnable = element.paramAccess;
                break;
            }
            break;
        }
        break;
    }
    state.specialAccessDetailMap = detailAccessMap;
  });
};

const setModuleFromPath = (state) => {
  var path = window.location.pathname;
  switch (path) {
    /*  case "/stlap/home/dashboard":
      state.programId = "MD000";
      state.moduleId = "MD000";
      break; */
    case "/stlap/home/disbursementCreatePortal":
      state.moduleId = "MD001";
      state.programId = "DB01";
      state.modeId = "DB01";
      break;
    case "/stlap/home/disbursementCreate":
      state.moduleId = "MD001";
      state.programId = "DB01";
      state.modeId = "DB01-C";
      break;
    case "/stlap/home/disbursementList":
      state.moduleId = "MD001";
      state.programId = "DB02";
      state.modeId = "DB02";
      break;
    case "/stlap/home/disbursementView":
      state.moduleId = "MD001";
      state.programId = "DB02";
      state.modeId = "DB02-V";
      break;
    case "/stlap/home/disbursementModify":
      state.moduleId = "MD001";
      state.programId = "DB02";
      state.modeId = "DB02-M";
      break;
    case "/stlap/home/disbursementCancel":
      state.moduleId = "MD001";
      state.programId = "DB02";
      state.modeId = "DB02-C";
      break;
    case "/stlap/home/disbursementApprovalList":
      state.moduleId = "MD001";
      state.programId = "DB03";
      state.modeId = "DB03";
      break;
    case "/stlap/home/disbursementApprove":
      state.moduleId = "MD001";
      state.programId = "DB03";
      state.modeId = "DB03-A";
      break;
    case "/stlap/home/nachMandate":
      state.moduleId = "MD002";
      state.programId = "NC01";
      state.modeId = "";
    case "/stlap/home/nachInward":
      state.programId = "MD002";
      state.moduleId = "NC02";
      state.modeId = "";
      break;
    case "/stlap/home/verification":
      state.moduleId = "MD002";
      state.programId = "NC03";
      state.modeId = "";
      break;
    case "/stlap/home/approval":
      state.moduleId = "MD002";
      state.programId = "NC05";
      state.modeId = "";
      break;

    case "/stlap/home/nachExclude":
      state.moduleId = "MD002";
      state.programId = "NC06";
      state.modeId = "";
      break;
    case "/stlap/home/nachRetrieval":
      state.moduleId = "MD002";
      state.programId = "NC07";
      state.modeId = "";
      break;
    case "/stlap/home/posting":
      state.moduleId = "MD002";
      state.programId = "NC08";
      state.modeId = "";
      break;
    case "/stlap/home/nachExtraction":
      state.moduleId = "MD002";
      state.programId = "NC09";
      state.modeId = "";
      break;
    /*   case "/stlap/home/retrival":
      state.moduleId = "MD002";
      state.programId = "NM10";
      break; */

    case "/stlap/home/parameter":
      state.moduleId = "MD003";
      state.programId = "MD003";
      state.modeId = "MD003";
      break;
    case "/stlap/home/fileReceiptCreate":
      state.moduleId = "MD004";
      state.programId = "FR01";
      state.modeId = "";
      break;
    case "/stlap/home/fileReceiptView":
      state.moduleId = "MD004";
      state.programId = "FR02";
      state.modeId = "FR02";
      break;
    case "/stlap/home/fileReceiptModify":
      state.moduleId = "MD004";
      state.programId = "FR03";
      state.modeId = "FR03";
      break;

    case "/stlap/home/filePaymentCreate":
      state.moduleId = "MD005";
      state.programId = "FP01";
      state.modeId = "FP01";
      break;
    case "/stlap/home/filePaymentView":
      state.moduleId = "MD005";
      state.programId = "FP02";
      state.modeId = "FP02";
      break;
    case "/stlap/home/filePaymentModify":
      state.moduleId = "MD005";
      state.programId = "FP03";
      state.modeId = "FP03";
      break;
    case "/stlap/home/filePaymentDelete":
      state.moduleId = "MD005";
      state.programId = "FP04";
      state.modeId = "FP04";
      break;
    case "/stlap/home/filePaymentApproval":
      state.moduleId = "MD005";
      state.programId = "FP05";
      state.modeId = "FP05";
      break;
    case "/stlap/home/jvCreate":
      state.moduleId = "MD006";
      state.programId = "JV01";
      state.modeId = "JV01";
      break;
    case "/stlap/home/jvView":
      state.moduleId = "MD006";
      state.programId = "JV02";
      state.modeId = "JV02";
      break;
    case "/stlap/home/jvEdit":
      state.moduleId = "MD006";
      state.programId = "JV03";
      state.modeId = "JV03";
      break;
    case "/stlap/home/jvDelete":
      state.moduleId = "MD006";
      state.programId = "JV04";
      state.modeId = "JV04";
      break;
    case "/stlap/home/jvApprove":
      state.moduleId = "MD006";
      state.programId = "JV05";
      state.modeId = "JV05";
      break;
    case "/stlap/home/chequeReturn":
      state.moduleId = "MD007";
      state.programId = "CR01";
      state.modeId = "CR01";
      break;
    case "/stlap/home/mandateReturn":
      state.moduleId = "MD007";
      state.programId = "CR02";
      state.modeId = "CR02";
      break;
    case "/stlap/home/bulkReturn":
      state.moduleId = "MD007";
      state.programId = "CR03";
      state.modeId = "";
      break;
    case "/stlap/home/additionalAccrual":
      state.moduleId = "MD008";
      state.programId = "AF01";
      state.modeId = "";
      break;
    case "/stlap/home/additionalWaiver":
      state.moduleId = "MD008";
      state.programId = "AF02";
      state.modeId = "";
      break;
    case "/stlap/home/batchScheduling":
      state.moduleId = "MD009";
      state.programId = "";
      state.modeId = "";
      break;
    case "/stlap/home/securityChequeCreate":
      state.moduleId = "MD010";
      state.programId = "SP01";
      state.modeId = "";
      break;
    case "/stlap/home/securityCheque":
      state.moduleId = "MD010";
      state.programId = "SP02";
      state.modeId = "";
      break;
    case "/stlap/home/cashHandlingCharge":
      state.moduleId = "MD011";
      state.programId = "MS01";
      state.modeId = "";
      break;
    case "/stlap/home/prePaymentHandling":
      state.moduleId = "MD011";
      state.programId = "MS02";
      state.modeId = "";
      break;
    case "/stlap/home/specialFunctionAccess":
      state.moduleId = "MD011";
      state.programId = "MS03";
      state.modeId = "";
      break;
      
    case "/stlap/home/lov":
      state.moduleId = "MD011";
      state.programId = "MS04";
      state.modeId = "";
      break;
     
    case "/stlap/home/losMaster":
      state.moduleId = "MD011";
      state.programId = "MS05";
      state.modeId = "";
      break;
      case "/stlap/home/feeDefinition":
        state.moduleId = "MD011";
        state.programId = "MS06";
        state.modeId = "";
        break;
        case "/stlap/home/feeRateDefinition":
        state.moduleId = "MD011";
        state.programId = "MS07";
        state.modeId = "";
        break;
    case "/stlap/home/amortCalculation":
      state.moduleId = "MD012";
      state.programId = "RP01";
      state.modeId = "";
      break;
    case "/stlap/home/reportProcess":
      state.moduleId = "MD012";
      state.programId = "RP02";
      state.modeId = "";
      break;
    case "/stlap/home/settlementFigureReport":
      state.moduleId = "MD012";
      state.programId = "RP03";
      state.modeId = "";
      break;
    case "/stlap/home/repaymentStructure":
      state.moduleId = "MD012";
      state.programId = "RP04";
      state.modeId = "";
      break;
    case "/stlap/home/loanClosure":
      state.moduleId = "MD013";
      state.programId = "";
      state.modeId = "";
      break;
    case "/stlap/home/reSchedulement":
      state.moduleId = "MD014";
      state.programId = "";
      state.modeId = "";
      break;
    case "/stlap/home/cov":
      state.moduleId = "MD015";
      state.programId = "";
      state.modeId = "";
      break;
      case "/lettergeneration/stlap/letterGenerationCreate":
        state.moduleId = "MD016";
        state.programId = "LG01";
        state.modeId = "";
        break;
        case "/lettergeneration/stlap/letterGenerationTrigger":
          state.moduleId = "MD016";
          state.programId = "LG02";
          state.modeId = "";
          break;
          case "/lettergeneration/stlap/letterGenerationTrigger":
            state.moduleId = "MD016";
            state.programId = "LG02";
            state.modeId = "";
            break;
            case "/stlap/home/losData/leadInfoList":
              state.moduleId = "MD017";
              state.programId = "LS01";
              state.modeId = "";
              break;
              case "/stlap/home/losData/customerInfoList":
                state.moduleId = "MD017";
                state.programId = "LS02";
                state.modeId = "";
                break;
                case "/stlap/home/losData/applicantInfoList":
                  state.moduleId = "MD017";
                  state.programId = "LS03";
                  state.modeId = "";
                  break;
    default:
      break;
  }
};

const getModeAccessData = (state, modeData) => {
  let modeAccessMap = {};
  switch (modeData.modeId) {
    case "DB02-M":

    case "DB02-V":
    case "DB02-C":
    case "DB01-C":
    case "DB03-A":
      modeAccessMap.disbursementView = modeData.modeAccess;

      break;
  }
  state.modeAccessMap = modeAccessMap;
};

const getFieldAccessData = (state, data) => {
  let fieldAccessMap = {};
  data.forEach((field) => {
    switch (field.fieldId) {
      case "DB01-C-DisbursementDate":
        //fieldAccessMap.disbursementDate = field.fieldAccess;
        fieldAccessMap.disbursementDateCreate = field.fieldAccess;
        if (field.fieldAccess) {
          getParamAccessData(state, field, fieldAccessMap);
        }
        break;
      case "DB02-M-DisbursementDate":
        fieldAccessMap.disbursementDateModify = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "NC01-M-NachDate":
        fieldAccessMap.nachMandateDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "NC05-NachApprovalDate":
        fieldAccessMap.nachApprovalDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "NC06-NachExcludeDate":
        fieldAccessMap.nachExcludeDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "NC07-NachRetrievalDate":
        fieldAccessMap.nachRetrievalDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "NC08-NachPostingDate":
        fieldAccessMap.nachPostingDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "NC09-MandateRegistrationFromDate":
        fieldAccessMap.nachExtractionFromDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "NC09-MandateRegistrationToDate":
        fieldAccessMap.nachExtractionToDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "FR01-VoucherDate":
        fieldAccessMap.receiptCreateVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "FR02-VoucherDate":
        fieldAccessMap.receiptViewVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "FR03-VoucherDate":
        fieldAccessMap.receiptModifyVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "FP01-VoucherDate":
        fieldAccessMap.paymentCreateVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "FP02-VoucherDate":
        fieldAccessMap.paymentViewVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "FP03-VoucherDate":
        fieldAccessMap.paymentModifyVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "FP04-VoucherDate":
        fieldAccessMap.paymentDeleteVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "FP05-VoucherDate":
        fieldAccessMap.paymentApproveVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "JV01-VoucherDate":
        fieldAccessMap.journalCreateVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "JV02-VoucherDate":
        fieldAccessMap.journalViewVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "JV03-VoucherDate":
        fieldAccessMap.journalModifyVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "JV04-VoucherDate":
        fieldAccessMap.journalDeleteVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "JV05-VoucherDate":
        fieldAccessMap.journalApproveVoucherDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "MS01-EffectiveDate":
        fieldAccessMap.cashHandlingEffectiveDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "MS02-EffectiveDate":
        fieldAccessMap.prePaymentHandlingEffectiveDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "MS05-EffectiveDate":
        fieldAccessMap.losMasterEffectiveDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
        case "MS06-EffectiveDate":
          fieldAccessMap.feeDefinitionEffectiveDate = field.fieldAccess;
          getParamAccessData(state, field, fieldAccessMap);
          break;
          case "MS07-EffectiveDate":
          fieldAccessMap.feeRateDefinitionEffectiveDate = field.fieldAccess;
          getParamAccessData(state, field, fieldAccessMap);
          break;
      case "SP01-ReceiptDate":
        fieldAccessMap.securityReceiptDateCreate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "SP02-ReceiptDate":
        fieldAccessMap.securityReceiptDateModify = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "RP01-AmortRequestDate":
        fieldAccessMap.amortRequestDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "RP02-ReportRequestDate":
        fieldAccessMap.reportRequestDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "RP03-SettlementFigureReportDate":
        fieldAccessMap.settlementFigureReport = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "RP03-SettlementFigureReportDate":
        fieldAccessMap.settlementFigureReport = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      case "RS01-EffectiveDate":
        fieldAccessMap.reSchedulementEffectiveDate = field.fieldAccess;
        getParamAccessData(state, field, fieldAccessMap);
        break;
      default:
        break;
    }
    state.fieldAccessMap = fieldAccessMap;
  });
};
const getParamAccessData = (state, field, fieldAccessMap) => {
  //if (fieldAccessMap.disbursementDateCreate) {
  switch (field.paramId) {
    case "DB01-C-DD-FC":
      //requestDateFutureCount
      fieldAccessMap.disbursementCreateRequestDateFutureCount =
        field.paramAccess;
      break;
    case "DB01-C-DD-BC":
      //requestDateBackCount
      fieldAccessMap.disbursementCreateRequestDateBackCount = field.paramAccess;
      break;
    case "NC05-A-AD-FC":
      fieldAccessMap.nachApprovalFutureCount = field.paramAccess;
      break;
    case "NC06-E-ND-BC":
      fieldAccessMap.nachExcludeBackCount = field.paramAccess;
      break;
    case "NC06-E-ND-FC":
      fieldAccessMap.nachExcludeFutureCount = field.paramAccess;
      break;
    case "NC07-R-RD-BC":
      fieldAccessMap.nachRetrievalBackCount = field.paramAccess;
      break;
    case "NC07-R-RD-FC":
      fieldAccessMap.nachRetrievalFutureCount = field.paramAccess;
      break;
    case "NC08-P-DD-BC":
      fieldAccessMap.nachPostingBackCount = field.paramAccess;
      break;
    case "NC08-P-DD-FC":
      fieldAccessMap.nachPostingFutureCount = field.paramAccess;
      break;
    case "NC09-E-FD-BC":
      fieldAccessMap.nachExtractionFromBackCount = field.paramAccess;
      break;
    case "NC09-E-FD-FC":
      fieldAccessMap.nachExtractionFromFutureCount = field.paramAccess;
      break;
    case "NC09-E-TD-BC":
      fieldAccessMap.nachExtractionToBackCount = field.paramAccess;
      break;
    case "NC09-E-TD-FC":
      fieldAccessMap.nachExtractionToFutureCount = field.paramAccess;
      break;
    case "FR01-C-VD-BC":
      fieldAccessMap.receiptCreateVoucherDateBackCount = field.paramAccess;
      break;
    case "FR01-C-VD-FC":
      fieldAccessMap.receiptCreateVoucherDateFutureCount = field.paramAccess;
      break;
    case "FR02-V-VD-BC":
      fieldAccessMap.receiptViewVoucherDateBackCount = field.paramAccess;
      break;
    case "FR02-V-VD-FC":
      fieldAccessMap.receiptViewVoucherDateFutureCount = field.paramAccess;
      break;
    case "FR03-M-VD-BC":
      fieldAccessMap.receiptModifyVoucherDateBackCount = field.paramAccess;
      break;
    case "FR03-M-VD-FC":
      fieldAccessMap.receiptModifyVoucherDateFutureCount = field.paramAccess;
      break;
    case "FP01-C-VD-BC":
      fieldAccessMap.paymentCreateVoucherDateBackCount = field.paramAccess;
      break;
    case "FP01-C-VD-FC":
      fieldAccessMap.paymentCreateVoucherDateFutureCount = field.paramAccess;
      break;
    case "FP02-V-VD-BC":
      fieldAccessMap.paymentViewVoucherDateBackCount = field.paramAccess;
      break;
    case "FP02-V-VD-FC":
      fieldAccessMap.paymentViewVoucherDateFutureCount = field.paramAccess;
      break;
    case "FP03-M-VD-BC":
      fieldAccessMap.paymentModifyVoucherDateBackCount = field.paramAccess;
      break;
    case "FP03-M-VD-FC":
      fieldAccessMap.paymentModifyVoucherDateFutureCount = field.paramAccess;
      break;
    case "FP04-D-VD-BC":
      fieldAccessMap.paymentDeleteVoucherDateBackCount = field.paramAccess;
      break;
    case "FP04-D-VD-FC":
      fieldAccessMap.paymentDeleteVoucherDateFutureCount = field.paramAccess;
      break;
    case "FP05-A-VD-BC":
      fieldAccessMap.paymentApprovalVoucherDateBackCount = field.paramAccess;
      break;
    case "FP05-A-VD-FC":
      fieldAccessMap.paymentApprovalVoucherDateFutureCount = field.paramAccess;
      break;
    case "JV01-C-VD-BC":
      fieldAccessMap.journalCreateVoucherDateBackCount = field.paramAccess;
      break;
    case "JV01-C-VD-FC":
      fieldAccessMap.journalCreateVoucherDateFutureCount = field.paramAccess;
      break;
    case "JV02-V-VD-BC":
      fieldAccessMap.journalViewVoucherDateBackCount = field.paramAccess;
      break;
    case "JV02-V-VD-FC":
      fieldAccessMap.journalViewVoucherDateFutureCount = field.paramAccess;
      break;
    case "JV03-M-VD-BC":
      fieldAccessMap.journalModifyVoucherDateBackCount = field.paramAccess;
      break;
    case "JV03-M-VD-FC":
      fieldAccessMap.journalModifyVoucherDateFutureCount = field.paramAccess;
      break;
    case "JV04-D-VD-BC":
      fieldAccessMap.journalDeleteVoucherDateBackCount = field.paramAccess;
      break;
    case "JV04-D-VD-FC":
      fieldAccessMap.journalDeleteVoucherDateFutureCount = field.paramAccess;
      break;
    case "JV05-A-VD-BC":
      fieldAccessMap.journalApprovalVoucherDateBackCount = field.paramAccess;
      break;
    case "JV05-A-VD-FC":
      fieldAccessMap.journalApprovalVoucherDateFutureCount = field.paramAccess;
      break;
    case "DB02-M-DD-BC":
      fieldAccessMap.requestDateModifyBackCount = field.paramAccess;
      break;
    case "DB02-M-DD-FC":
      fieldAccessMap.requestDateModifyFutureCount = field.paramAccess;
      break;
    case "MS01-C-ED-FC":
      fieldAccessMap.cashHandlingFutureCount = field.paramAccess;
      break;
    case "MS01-C-ED-BC":
      fieldAccessMap.cashHandlingBackCount = field.paramAccess;
      break;
    case "MS02-P-ED-BC":
      fieldAccessMap.prePaymentFutureCount = field.paramAccess;
      break;
    case "MS02-P-ED-FC":
      fieldAccessMap.prePaymentBackCount = field.paramAccess;
      break;
    case "MS05-L-ED-FC":
      fieldAccessMap.losMasterEffectiveDateFutureCount = field.paramAccess;
      break;
    case "MS05-L-ED-BC":
      fieldAccessMap.losMasterEffectiveDateBackCount = field.paramAccess;
      break;
      case "MS05-L-ED-FC":
        fieldAccessMap.losMasterEffectiveDateFutureCount = field.paramAccess;
        break;
      case "MS05-L-ED-BC":
        fieldAccessMap.losMasterEffectiveDateBackCount = field.paramAccess;
        break;
        case "MS06-F-ED-BC":
          fieldAccessMap.feeDefinitionEffectiveDateBackCount = field.paramAccess;
          break;
          case "MS06-F-ED-FC":
          fieldAccessMap.feeDefinitionEffectiveDateFutureCount = field.paramAccess;
          break;
          case "MS07-F-ED-BC":
            fieldAccessMap.feeRateDefinitionEffectiveDateBackCount = field.paramAccess;
            break;
            case "MS07-F-ED-FC":
            fieldAccessMap.feeRateDefinitionEffectiveDateFutureCount = field.paramAccess;
            break;
    case "SP01-C-RD-BC":
      fieldAccessMap.securityChequeCreateBackCount = field.paramAccess;
      break;
    case "SP01-C-RD-FC":
      fieldAccessMap.securityChequeCreateFutureCount = field.paramAccess;
      break;
    case "RP01-A-RD-BC":
      fieldAccessMap.amortRequestDateBackCount = field.paramAccess;
      break;
    case "RP01-A-RD-FC":
      fieldAccessMap.amortRequestDateFutureCount = field.paramAccess;
    case "RP02-R-RD-BC":
      fieldAccessMap.reportRequestDateBackCount = field.paramAccess;
      break;
    case "RP02-R-RD-FC":
      fieldAccessMap.reportRequestDateFutureCount = field.paramAccess;
      break;
    case "RP03-S-ED-BC":
      fieldAccessMap.settlementFigureBackCount = field.paramAccess;
      break;
    case "RP03-S-ED-FC":
      fieldAccessMap.settlementFigureFutureCount = field.paramAccess;
      break;
    case "RS01-C-ED-BC":
      fieldAccessMap.reSchedulementEffectiveDateBackCount = field.paramAccess;
      break;
    case "RS01-C-ED-FC":
      fieldAccessMap.reSchedulementEffectiveDateFutureCount = field.paramAccess;
      break;
    default:
      break;
  }
  // }
  // if (fieldAccessMap.disbursementDateModify) {
  /*  switch (field.paramId) {
  } */
  //  }
  state.fieldAccessMap = fieldAccessMap;
};

const updateSpecialAccess = (state, accessValue) => {
  state.specialAccessValue = accessValue;
};
const SpecialAccessDetailReducer = createSlice({
  name: "specialAccess",
  initialState: initialState,
  reducers: {
    getHeaderData(state, action) {
      getHeaderAccessData(state, action.payload);
    },
    getDetailData(state, action) {
      getDetailData(state, action.payload);
    },
    setUserDetails(state,action){
      state.userId = action.payload
    },
    setModuleDetails(state) {
      setModuleFromPath(state);
    },
    getModeData(state, action) {
      getModeAccessData(state, action.payload);
    },
    getFieldData(state, action) {
      getFieldAccessData(state, action.payload);
    },
    updateSpecialAccess(state, action) {
      updateSpecialAccess(state, action.payload);
    },
    setParameterData(state, action) {
      state.paramValues = action.payload;
    },
  },
});
export const SpecialAccessDetailAction = SpecialAccessDetailReducer.actions;
export default SpecialAccessDetailReducer.reducer;
